import React from "react";
import { useTranslation } from "react-i18next";

//Material-UI Core Components
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

//Material-UI Icons
import FingerprintIcon from "@material-ui/icons/Fingerprint";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import StarIcon from "@material-ui/icons/Star";

//Custom components

function FormHeadingIDAndBS(props) {
  const { t } = useTranslation();

  const { record } = props;

  const id = record.id;
  const owner = record.narucitelj_naziv;
  const ocjena = record.narucitelj_ocjena;

  return (
    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", marginLeft: "10px" }}>
      <Tooltip title={t("common.id")}>
        <div style={{ display: "flex", alignItems: "center", marginRight: 16 }}>
          <FingerprintIcon style={{ marginRight: 8 }} />
          <Typography align="left" variant="subtitle2">
            {id}
          </Typography>
        </div>
      </Tooltip>
      <Tooltip title={t("common.published_by")}>
        <div style={{ display: "flex", alignItems: "center", marginRight: 16 }}>
          <AccountBoxIcon style={{ marginRight: 8 }} />
          <Typography align="left" variant="subtitle2">
            {owner}
          </Typography>
        </div>
      </Tooltip>
      <Tooltip title={t("common.ocjena")}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <StarIcon style={{ marginRight: 8 }} />
          <Typography align="left" variant="subtitle2">
            {ocjena}
          </Typography>
        </div>
      </Tooltip>
    </div>
  );
}

export default FormHeadingIDAndBS;
